import React from 'react'
import "../styles/RestartButton.css"
const RestartButton = () => {
    const handleRefresh = () => {
        window.location.reload();
    };
  return (
    <button onClick={handleRefresh} className="restart-button">
        <img src="/refresh.svg" alt="Refresh Actors"
        style={
            {
                objectFit: 'contain',
                width: '100%',
                height: '100%',
            }
        }/>
    </button>
  )
}

export default RestartButton